export default "__VITE_ASSET__FuL3DKND__"